import React from 'react';
import { useScrollTrigger, Zoom, Fab } from '@material-ui/core';
import { KeyboardArrowUp } from '@material-ui/icons';
import useStyles from './useStyles';

const ScrollTop = function ScrollTop(): React.ReactElement {
  const classes = useStyles();

  const trigger = useScrollTrigger({
    disableHysteresis: true
  });

  const handleClick = function handleClick(): void {
    const anchor = document.querySelector('#back-to-top-anchor');

    if (anchor) {
      anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return (
    <Zoom in={trigger}>
      <div
        onClick={handleClick}
        role='presentation'
        className={classes.scrollTopButton}
      >
        <Fab color='secondary' size='small' aria-label='scroll back to top'>
          <KeyboardArrowUp />
        </Fab>
      </div>
    </Zoom>
  );
};

export default ScrollTop;
